import React from "react";
import ReactDOM from "react-dom";
import "./tailwind.css";
import App from "./App";

// Ensure jQuery is available globally for Luckysheet
declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}

// jQuery is loaded from CDN in index.html

ReactDOM.render(<App />, document.getElementById("root")); 